import React, { useEffect, useState } from 'react'
import SPage, { SPageType } from '../../../components/opinionless/SPage'
import ApplicationStep1 from '../steps/ApplicationStep1'
import ApplicationStep0 from '../steps/ApplicationStep0'
import ApplicationStep4 from '../steps/ApplicationStep4'
import ApplicationStep3 from '../steps/ApplicationStep3'
import { useRouter } from 'next/router'
import ConditionalRender from '../../../utils/conditionalRender'
import StepDots from '../steps/StepDots'
import { useSTheme } from '../../../styles/theme'
import { useOrganization } from '../../../v2/context/organization'

interface Props {}

const ApplicantsContainer: React.FC<Props> = (props: Props) => {
    const router = useRouter()
    const theme = useSTheme()
    const { program } = useOrganization()

    if (window.location.href.indexOf('longbeachpledge.org') > -1 && window.location.pathname == '/apply') {
        void router.replace('/program/apply')
        return null
    }

    const [successMessage, setSuccessMessage] = useState('')
    const [currentStep, setCurrentStep] = useState(0)
    const [applicationId, setApplicationId] = useState(null)

    const defaultFontFamily = theme.fonts.default

    useEffect(() => {
        if (process.env.NEXT_PUBLIC_ENVIRONMENT_NAME === 'production') {
            router.push(`${window.PERSON?.applicationDetails[0].program?.urlFragment || program.urlFragment}/login`)
        }
    }, [])

    useEffect(() => {
        if (successMessage) {
            setTimeout(() => setSuccessMessage(''), 3000)
        }
    }, [successMessage])

    return (
        <SPage
            pageType={SPageType.Unauthed}
            display={'flex'}
            sx={{
                alignItems: 'center',
                justifyContent: ['row', 'center', 'center'],
                flexDirection: 'column',
                position: 'relative',
            }}
        >
            <>
                {currentStep === 0 && (
                    <ApplicationStep0 setCurrentStep={setCurrentStep} fontFamily={defaultFontFamily} />
                )}
                {currentStep === 1 && (
                    <ApplicationStep1
                        setCurrentStep={setCurrentStep}
                        onSuccess={setApplicationId}
                        fontFamily={defaultFontFamily}
                    />
                )}

                {currentStep === 2 && (
                    <ApplicationStep3
                        setCurrentStep={setCurrentStep}
                        applicationId={applicationId}
                        fontFamily={defaultFontFamily}
                    />
                )}
                {currentStep === 3 && (
                    <ApplicationStep4
                        setCurrentStep={setCurrentStep}
                        applicationId={applicationId}
                        fontFamily={defaultFontFamily}
                    />
                )}
                <ConditionalRender if={currentStep >= 1}>
                    <StepDots stepLength={3} currentStep={currentStep} />
                </ConditionalRender>
            </>
        </SPage>
    )
}

export default ApplicantsContainer
